import { Container } from '@chakra-ui/react';
import { BlockRenderer } from '../Fields/BlockRenderer';
import { resolveFields } from '../Fields';
import { CampaignPagePost } from '../../types';
import ArticleContainer from '../ArticleContainer';
import Breadcrumb from '../Breadcrumb';
import TeaserHeroFull from '../TeaserHeroFull';
import HeroCentered from '../HeroCentered';
import { splitFields } from './Page';
import { BlocksProvider } from '../../lib/blocks.context';

const showHero = (hero) => {
  const { name } = hero;
  return name === 'hero-centered' ? (
    <HeroCentered {...hero} />
  ) : (
    <TeaserHeroFull gridRow="1" {...hero} />
  );
};

const CampaignPage = ({ fields }: CampaignPagePost) => {
  const [hero, contentFields] = resolveFields(fields);
  const { basicFields, sectionFields } = splitFields(contentFields, [
    'core/paragraph',
    'core/heading',
    'video',
    'accordion',
    'membership-fee',
    'board-members',
    'buttons',
  ]);

  return (
    <ArticleContainer>
      <Breadcrumb zIndex="1" gridRow="1" mb="auto" />
      {hero && showHero(hero)}
      {basicFields && basicFields.length > 0 && (
        <Container maxW="container.sm" variant="noSpacing">
          <BlocksProvider value={{ layoutType: 'basic' }}>
            <BlockRenderer blocks={basicFields} />
          </BlocksProvider>
        </Container>
      )}
      {sectionFields && <BlockRenderer blocks={sectionFields} />}
    </ArticleContainer>
  );
};

export default CampaignPage;
